import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { MonthRevenue,MonthExpense,MonthProfit } from './expensesIcons';
import { numberFormat } from '../../../utils/utils';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { Button } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  infoCard: {
    padding: '0px 16px',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #ddd'
  },
  infoBOX:{
    padding:'12px 16px'
  },
  valueBox:{
      marginLeft:16
  },
  iconBox:{
    padding:6,
    borderRadius:'50%'
  },
  pnlLabel:{
      color:'rgba(11, 19, 35, 0.75)',
      fontSize:12,
      margin:0
  },
  pnlValue:{
      color:'#0b1323',
      fontSize:18,
      fontWeight:600,
      margin:0
  },
  viewPDFCta: {
      backgroundColor: '#0033cc',
      borderRadius: 4,
      border: 0,
      color: 'white',
      height: 36,
      padding: '7px 16px 7px 12px',
      textTransform: 'capitalize',
      '&:hover': {
          backgroundColor: '#0033cc'
      },
      fontWeight: 'normal',
      minWidth: 132
  },
  divAlign: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
  },
  mlV3: {
      marginLeft: 8
  }
}));
const ExpensesSparkline = (props) => {
  const {
      pnlValues,
      viewPdfAction
  } = props;
  const classes = useStyles();
  let values= [
      {
        icon:<MonthRevenue />,
        name:'Month Revenue',
        value:pnlValues&& pnlValues.revenue && pnlValues.revenue.overall?pnlValues.revenue.overall:0,
        bg:'#edf0ff'
      },
      {
        icon:<MonthExpense />,
        name:'Month Expense',
        value:pnlValues&& pnlValues.cost && pnlValues.cost.overall?pnlValues.cost.overall:0,
        bg:'#ffebeb'
      },
      {
        icon:<MonthProfit />,
        name:'Month Profit',
        value:pnlValues&& pnlValues.profit && pnlValues.profit.overall?pnlValues.profit.overall:0,
        bg:'#e8fff1'
      }
  ]
  return (
    <>
      <Box className={classes.infoCard} >
        {
            values&&values.map((val)=>{
                return <Box display={'flex'} alignItems={'center'} className={classes.infoBOX}>
                        <Box component={'div'} className={classes.iconBox} style={{backgroundColor:val.bg}}>
                            {val.icon}
                        </Box>
                        <Box className={classes.valueBox}>
                            <Typography className={classes.pnlLabel}>{val.name}</Typography>
                            <Typography  className={classes.pnlValue}>{numberFormat(val.value)}</Typography>
                        </Box>
                </Box>
            })
        }
        <Button variant="contained" classes={{ root: classes.viewPDFCta }} onClick={() => {viewPdfAction()}}>
          <div className={classes.divAlign} >
              <PictureAsPdfIcon />
              <div className={classes.mlV3} >&nbsp;View Report</div>
          </div>
      </Button>
      </Box>
    </>
  );
}
export default ExpensesSparkline;